module.exports = __webpack_public_path__ + "img/dots-1.423ac9d5.svg";